<template>
  <v-form v-bind="this.$attrs">
    <div>
      <v-row no-gutters>
        <v-col cols="5">
          <v-select
            :items="exams"
            v-model="exam"
            label="Chọn kỳ kiểm tra"
            item-value="id"
            item-text="name"
            return-object
            outlined
            dense
            clearable
            hide-details
            @change="examSelected"
            class="pr-6"
          ></v-select>
        </v-col>
        <v-col cols="5">
          <v-select
            :items="seatedOptions"
            v-model="seated"
            label="Trạng thái học sinh"
            item-value="value"
            item-text="label"
            outlined
            dense
            hide-details
            class="pr-6"
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-btn
            :disabled="!exam"
            height="40"
            width="100%"
            style="background-color: white"
            color="#0D47A1"
            @click="onFilterChanged"
            outlined
          >
            Xác nhận
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div class="pt-6" v-if="exam && seated !== 'notSeated'">
      <v-row no-gutters>
        <v-col cols="5">
          <v-select
            :items="rooms"
            v-model="room"
            label="Chọn phòng thi"
            item-value="id"
            item-text="name"
            return-object
            clearable
            outlined
            dense
            hide-details
            class="pr-6"
          ></v-select>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {},
  data() {
    return {
      exam: '',
      subject: '',
      room: '',
      seated: '',
      exams: [],
      subjects: [],
      rooms: [],
      subjectGroups: [],
      products: [],
      seatedOptions: [
        { label: 'Tất cả', value: '' },
        { label: 'Đã xếp', value: 'seated' },
        { label: 'Đang xếp', value: 'seating' },
        { label: 'Chưa xếp', value: 'notSeated' }
      ]
    }
  },
  async mounted() {
    await this.getExams()
  },
  methods: {
    ...mapActions('subjectExam', ['fetchSubjects']),
    ...mapActions('subjectExamGroup', ['fetchSubjectGroups']),
    ...mapActions('room', ['fetchRooms']),
    ...mapActions('exam', ['fetchExams']),
    onFilterChanged() {
      const params = {
        exam: this.exam.id,
        rooms: this.room ? this.room.id : '',
        status: this.seated
      }
      this.$emit(
        'onFilterChanged',
        params,
        this.subjects,
        this.rooms,
        this.exam.type,
        this.exam.grade,
        this.subjectGroups,
        this.products
      )
    },
    async getExams() {
      this.$loading.active = true
      this.exams = await this.fetchExams({ status: 'active' })
      this.$loading.active = false
    },

    async getRooms(query) {
      this.rooms = await this.fetchRooms({ ...query, _limit: -1 })
    },
    async getSubjects(query) {
      this.subjects = await this.fetchSubjects(query)
    },
    async getSubjectGroups(query) {
      this.subjectGroups = await this.fetchSubjectGroups(query)
    },
    async examSelected() {
      this.$loading.active = true
      await this.getSubjects({ exam: this.exam ? this.exam.id : '' })
      await this.getRooms({ exam: this.exam ? this.exam.id : '', _limit: -1 })
      await this.getSubjectGroups({ exam: this.exam ? this.exam.id : '' })
      this.room = ''
      this.subject = ''

      this.$loading.active = false
    }
  }
}
</script>

<style scoped>
.invis-btn {
  background-color: transparent !important;
  color: transparent !important;
  border: none !important;
}
</style>
